import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DropzoneArea } from "material-ui-dropzone";
import DateTimePicker from "react-datetime";
import SelectFilter from "react-select";
import Checkbox from "@material-ui/core/Checkbox";
import MyButton from "./MyButton";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");

class FilterSuKienDialog extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOK = this.handleOK.bind(this);
    this.state = {
      canSaved: true, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_sukien: false,
      source_sukien: [],
      before: props.value === undefined ? {} : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              TrangThai: "1",
              LoaiTau_TauHang: true,
              LoaiTau_TauCa: true,
              LoaiTau_TauKhac: true,
              TuNgay: null,
              DenNgay: null,
            }
          : props.value, //thong tin dang edit
    };
  }
  componentDidMount() {}
  static getDerivedStateFromProps(props, state) {
    return state;
  }
  handleCancel = () => {
    this.props.callback(false);
  };
  handleOK = () => {
    //thuc hien tim kiem
    this.setState({ saving: true, errorLog: "" });
    server
      .post("sukien/filter", this.state.after)
      .then((response) => {
        var after = myLib.cloneObject(this.state.after);
        this.setState({
          dataChanged: false,
          canSaved: true,
          saving: false,
          errorLog: "",
          search_result: response,
        });
        //thong bao cho parent biet co data duoc saved
        if (this.props.onSearched) {
          this.props.onSearched(after, response);
        }
      })
      .catch((error) =>
        this.setState({
          saving: false,
          errorLog: error + "",
        })
      );
  };
  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    var s = this.state;
    s.after[fieldName] = value;
    s.dataChanged = !myLib.isSame(s.before, s.after, [
      "TrangThai",
      "LoaiTau_TauHang",
      "LoaiTau_TauCa",
      "LoaiTau_TauKhac",
      "TuNgay",
      "DenNgay",
    ]);
    s.canSaved = s.dataChanged;
    this.setState(s);
  };
  render() {
    const { classes, theme } = this.props;
    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="md"
        fullWidth={true}
        aria-labelledby="confirmation-dialog-title"
        open={true}
      >
        <DialogTitle id="confirmation-dialog-title">
          Lọc và hiển thị sự vụ
        </DialogTitle>
        <DialogContent dividers>
          <div style={{height: 350}}>
            <Grid container spacing={3}>
              <Grid item xs={3}>
                <FormControl className={classes.formControl}>
                  <InputLabel id="demo-simple-select-label">
                    Trạng thái:
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    className={classes.textbox}
                    autoWidth={true}
                    labelWidth={100}
                    value={this.state.after.TrangThai}
                    onChange={(event) =>
                      this.saveField("TrangThai", event.target.value)
                    }
                  >
                    <MenuItem value={"1"}>Đang xử lý</MenuItem>
                    <MenuItem value={"2"}>Kết thúc</MenuItem>
                    <MenuItem value={"-1"}>Tất cả</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={9}></Grid>
              <Grid item xs={3}>
                <InputLabel id="labelTungay">Từ ngày:</InputLabel>
                <DateTimePicker
                  id="txtTuNgay"
                  dateFormat="DD/MM/YYYY"
                  className={classes.thoigian}
                  timeFormat={false}
                  closeOnSelect={true}
                  value={this.state.after.TuNgay}
                  inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.TuNgay === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('TuNgay', date);
                      }
                    }
                  }
                }}
                  onChange={(date) =>
                    this.saveField(
                      "TuNgay",
                      date && date.toDate ? date.toDate() : null
                    )
                  }
                />
              </Grid>
              <Grid item xs={3}>
                <InputLabel id="labelTungay">Đến ngày:</InputLabel>
                <DateTimePicker
                  id="txtDenNgay"
                  dateFormat="DD/MM/YYYY"
                  className={classes.thoigian}
                  timeFormat={false}
                  closeOnSelect={true}
                  value={this.state.after.DenNgay}
                  inputProps={{
                  maxLength: 100,
                  onBlur: (event) => {
                    var text = event.target.value;
                    if(this.state.after.DenNgay === null && text != '') {
                      var date = myLib.tryToDate(text);
                      if(date) {
                        this.saveField('DenNgay', date);
                      }
                    }
                  }
                }}
                  onChange={(date) =>
                    this.saveField(
                      "DenNgay",
                      date && date.toDate ? date.toDate() : null
                    )
                  }
                />
              </Grid>
              <Grid item xs={12}>
                {/**Loc theo loai tau */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.after.LoaiTau_TauHang}
                      onChange={(event) =>
                        this.saveField("LoaiTau_TauHang", event.target.checked)
                      }
                      name="chk1"
                    />
                  }
                  label="Tàu hàng"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.after.LoaiTau_TauCa}
                      onChange={(event) =>
                        this.saveField("LoaiTau_TauCa", event.target.checked)
                      }
                      name="chk2"
                    />
                  }
                  label="Tàu cá"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={this.state.after.LoaiTau_TauKhac}
                      onChange={(event) =>
                        this.saveField("LoaiTau_TauKhac", event.target.checked)
                      }
                      name="chk3"
                    />
                  }
                  label="Tàu khác"
                />
              </Grid>
              <Grid item xs={12}>
                <div style={{ height: 100 }}>
                  {this.state.saving ? (
                    <CircularProgress />
                  ) : this.state.errorLog === "" ? null : (
                    this.state.errorLog
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions>
          <MyButton
            onClick={this.handleOK}
            color="primary"
            text="OK"
            disabled={!this.state.canSaved}
          />
          <MyButton onClick={this.handleCancel} color="primary" text="Cancel" />
        </DialogActions>
      </Dialog>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
});
export default withStyles(styles, { withTheme: true })(FilterSuKienDialog);
